import './gh_auth_form.scss';
import '../config.js';
import gudhubLogoUrl from './images/gudhub-logo.svg';
import easyStoneShopLogoUrl from './images/easystoneshop-logo.svg';

/* ---------------------------------------------------------------------------------------------------------------- */
/* VALIDATION RULES. Single source for every layout: the page layout (login / signup) and the legacy window layout */
/* (update). Kept as attribute strings because both layouts are HTML strings compiled with $compile.               */
/* ---------------------------------------------------------------------------------------------------------------- */
var VALIDATION = {
    name: 'ng-pattern="/^[a-zA-Z0-9\\s.&]+$/" ng-minlength="3" required',
    email: 'ng-pattern="/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/" required',
    password: 'ng-pattern="/^[a-zA-Z0-9]+$/" ng-minlength="4" required'
};

/* Logo of the page layout by cnfg.logo_id (LOGO_ID in .env). Unknown or empty LOGO_ID falls back to GudHub */
var LOGOS = {
    gudhub_logo: { url: gudhubLogoUrl, alt: 'GudHub' },
    easystoneshop_logo: { url: easyStoneShopLogoUrl, alt: 'EasyStoneShop' }
};

/* Modes rendered with the page layout of gudhub.com/login and gudhub.com/sign-up */
var PAGE_MODES = ['login', 'signup'];

/* Keyboard and autocorrect hints for email inputs. Validation stays on ng-pattern, so the type remains "text" */
var EMAIL_HINTS = 'inputmode="email" autocapitalize="off" spellcheck="false"';

/* Error messages of the page layout, checked in this order. "empty" is a confirm field left blank */
var ERROR_MESSAGES = {
    first_name: {
        required: 'Enter your first name',
        pattern: 'Use Latin letters, numbers, spaces, dots or &',
        minlength: 'First name must be at least 3 characters'
    },
    last_name: {
        required: 'Enter your last name',
        pattern: 'Use Latin letters, numbers, spaces, dots or &',
        minlength: 'Last name must be at least 3 characters'
    },
    email: {
        required: 'Enter your email',
        pattern: 'Enter a valid email, e.g. name@example.com'
    },
    password: {
        required: 'Enter your password',
        pattern: 'Use only Latin letters and numbers',
        minlength: 'Password must be at least 4 characters'
    },
    confirm_password: {
        empty: 'Repeat your password',
        confirm: "Passwords don't match"
    }
};

/* ---------------------------------------------------------------------------------------------------------------- */
/* PASSWORD STRENGTH of the signup password. Advisory only: the form still requires just VALIDATION.password.     */
/* Entropy of the character pool over the length left after discounting what is guessed first: common words,    */
/* the user's own name or email, repeats and sequences (aaaa, 1234, abcd)                                         */
/* ---------------------------------------------------------------------------------------------------------------- */
var STRENGTH_LEVELS = [
    { label: 'Weak', modifier: 'weak' },
    { label: 'Fair', modifier: 'fair' },
    { label: 'Good', modifier: 'good' },
    { label: 'Strong', modifier: 'strong' }
];

/* Bits at which Fair, Good and Strong start */
var STRENGTH_BITS = [36, 50, 66];

var COMMON_FRAGMENTS = ['password', 'passw0rd', 'qwerty', 'asdf', 'zxcv', 'admin', 'login'];

/* Returns null for an empty password, otherwise { score: 1-4, label, modifier, tip } */
function rateNewPassword(password, personal) {
    if (!password) {
        return null;
    }

    var rest = password.toLowerCase();
    var tips = {};

    /* Every found word shrinks to one placeholder character */
    function discount(word, tip) {
        if (word.length >= 3 && rest.indexOf(word) !== -1) {
            rest = rest.split(word).join('\u0000');
            tips[tip] = true;
        }
    }

    personal.forEach(function (value) {
        String(value || '').toLowerCase().split(/[^a-z0-9]+/).forEach(function (word) {
            discount(word, 'personal');
        });
    });
    COMMON_FRAGMENTS.forEach(function (word) {
        discount(word, 'common');
    });

    /* From the third character of a run (aaa, 123, cba) every next one adds a quarter of a character */
    var length = 0;
    var run = 0;
    for (var i = 0; i < rest.length; i++) {
        var patterned = i > 0 && Math.abs(rest.charCodeAt(i) - rest.charCodeAt(i - 1)) <= 1;
        run = patterned ? run + 1 : 0;
        length += run >= 2 ? 0.25 : 1;
        if (run >= 2) {
            tips.pattern = true;
        }
    }

    var classes = [/[a-z]/, /[A-Z]/, /[0-9]/, /[^a-zA-Z0-9]/];
    var sizes = [26, 26, 10, 33];
    var pool = 0;
    var variety = 0;
    classes.forEach(function (regexp, index) {
        if (regexp.test(password)) {
            pool += sizes[index];
            variety++;
        }
    });

    var bits = length * Math.log2(pool);
    var score = 1 + STRENGTH_BITS.filter(function (threshold) {
        return bits >= threshold;
    }).length;

    var tip = '';
    if (score < 4) {
        if (tips.personal) tip = 'Avoid your name or email';
        else if (tips.common) tip = 'Avoid common words and keyboard patterns';
        else if (tips.pattern) tip = 'Avoid repeats and sequences like 1234';
        else if (password.length < 12) tip = 'Use 12 or more characters';
        else if (variety < 3) tip = 'Mix upper and lower case letters and numbers';
        else tip = 'Add a few more characters';
    }

    return angular.extend({ score: score, tip: tip }, STRENGTH_LEVELS[score - 1]);
}

angular.module('ghAuthFormModule', [
    'authorizationMod',
    'mainStorage',
    'config'
])
    .directive('ghAuthForm', [ '$document', '$location', '$routeParams', '$timeout', '$compile', 'storage', 'AuthFormService', 'cnfg', function($document, $location, $routeParams, $timeout, $compile, storage, AuthFormService, cnfg) {
        return {
            restrict: 'E',
            scope: {
                ghData: '@', /* Must be: 'login', 'update', 'signup' */
            },
            controller: [ '$scope', '$element', '$attrs', async function($scope, $element, $attrs) {
                $scope.auth_form = {};

                /* VARIABLE for checked change avatar */
                var change_avatar = false;
                $scope.auth_form.email = $routeParams.email;
                $scope.storage_user = angular.copy(storage.getMainStorage().user);

                $scope.$watch('storage_user.avatar_512', function(newVal, oldVal){
                    if (newVal !== oldVal) {
                        change_avatar = true;
                    }
                });

                $scope.formSettings = {
                    login:{
                        title: 'Login',
                        buttonName: 'Log In',
                        uploadAvatar: false,
                        showSwitch: cnfg.saas_mode, // sign up is available only in SaaS mode (SAAS_MODE in .env)
                        switchQuestion: "Don't have an account yet?",
                        switchLinkName: 'Sign Up',
                        switchLinkHref: '/signup'
                    },
                    update:{
                        title: 'Account Settings',
                        buttonName: 'Update',
                        cancelButton: true,
                        uploadAvatar: true
                    },
                    signup:{
                        title: 'Sign Up',
                        buttonName: 'Register',
                        continueButtonName: 'Continue',
                        backButtonName: 'Back',
                        uploadAvatar: false,
                        showSwitch: true, // invited users open /signup in every mode and may already have an account
                        switchQuestion: 'Already have an account?',
                        switchLinkName: 'Login',
                        switchLinkHref: '/login'
                    }
                };

                $scope.avatar_field_model = {
                    image_size: 512,
                    avatar_size: 180,
                    uploadEvents: $scope.formSettings[$scope.ghData].uploadAvatar
                };

                $scope.back = function () {
                    $location.path('/');
                };

                $scope.destroyWindow = function () {
                    $scope.$parent.destroyWindow();
                };

                if ($scope.storage_user && $scope.ghData == 'update') {
                    $scope.auth_form = {
                        email: angular.copy($scope.storage_user.username),
                        first_name: $scope.storage_user.fullname.split(' ')[0] || '',
                        last_name: $scope.storage_user.fullname.split(' ')[1] || ''
                    };
                }

                /* Returns the request promise so the page layout knows when it settles */
                $scope.send = function () {
                    var userData = angular.copy($scope.auth_form);

                    if (change_avatar) {
                        userData.avatar = $scope.storage_user.avatar_512.replace(/^data:image\/(gif|jpg|jpeg|tiff|png);base64,/, "");
                    }

                    if ($scope.authForm.$valid) {
                        return AuthFormService[$scope.ghData](userData).then(function() {

                        }, function(err) {
                            $scope.errMsg = err;
                            $timeout(function() {
                                $scope.errMsg = "";
                            }, 1500);
                        });
                    }
                };

                if ($scope.ghData === 'login') {
                    AuthFormService.autoLoginFromParams();
                }

                /* ------------------------------------ PAGE LAYOUT STATE (login / signup) ------------------------------------ */
                /* View state only: requests, validation and error handling stay in send() and AuthFormService               */
                /* Bound with ng-src: the URL is set through the DOM, whatever characters the loader puts in it */
                $scope.logo = LOGOS[cnfg.logo_id] || LOGOS.gudhub_logo;

                var ui = $scope.ui = {
                    step: 1,          // signup: 1 - email, 2 - name, 3 - password
                    attempted: false, // Continue / submit pressed: reveal every error of the visible step
                    pending: false,   // request in flight: the fieldset is disabled
                    visible: {},      // password fields switched to plain text
                    capsLock: null,   // password field being typed into with Caps Lock on
                    strength: null    // signup: rateNewPassword() of the typed password
                };

                /* The view value, so the meter also rates a password that is still too short to be valid */
                if ($scope.ghData === 'signup') {
                    $scope.$watchGroup([
                        function () { return $scope.authForm && $scope.authForm.password.$viewValue; },
                        function () { return $scope.authForm && $scope.authForm.email.$viewValue; },
                        'auth_form.first_name',
                        'auth_form.last_name'
                    ], function (values) {
                        var email = (values[1] || '').split('@')[0];
                        ui.strength = rateNewPassword(values[0], [email, values[2], values[3]]);
                    });
                }

                $scope.showError = function (name) {
                    var field = $scope.authForm && $scope.authForm[name];
                    return Boolean(field && field.$invalid && (ui.attempted || (field.$dirty && field.$touched)));
                };

                $scope.errorText = function (name) {
                    var field = $scope.authForm && $scope.authForm[name];
                    var messages = ERROR_MESSAGES[name];

                    if (!field || !messages) {
                        return '';
                    }
                    if (field.$error.confirm && !field.$viewValue) {
                        return messages.empty;
                    }

                    var failed = Object.keys(messages).find(function (rule) {
                        return field.$error[rule];
                    });
                    return failed ? messages[failed] : '';
                };

                $scope.toggleVisibility = function (name) {
                    ui.visible[name] = !ui.visible[name];
                };

                $scope.detectCapsLock = function (event, name) {
                    ui.capsLock = event.getModifierState && event.getModifierState('CapsLock') ? name : null;
                };

                $scope.goToStep = function (step) {
                    ui.step = step;
                    ui.attempted = false;

                    var field = '#gh-auth-email';
                    if (step === 2) field = '#gh-auth-first-name';
                    if (step === 3) field = '#gh-auth-password';

                    focusField(field);
                };

                $scope.submit = function () {
                    var form = $scope.authForm;

                    if ($scope.ghData === 'signup') {
                        if (ui.step === 1) {
                            return form.email.$valid ? $scope.goToStep(2) : revealErrors();
                        }
                        if (ui.step === 2) {
                            return form.first_name.$valid && form.last_name.$valid ? $scope.goToStep(3) : revealErrors();
                        }
                    }

                    if (form.$invalid) {
                        return revealErrors();
                    }

                    var request = $scope.send();
                    if (request) {
                        ui.pending = true;
                        request.finally(function () {
                            ui.pending = false;
                        });
                    }
                };

                function revealErrors() {
                    ui.attempted = true;
                    focusField('.gh-auth__step:not(.ng-hide) input.ng-invalid');
                }

                /* Runs after the digest, when ng-show has already revealed the target step */
                function focusField(selector) {
                    $timeout(function () {
                        var target = $element[0].querySelector(selector);
                        if (target) {
                            target.focus();
                        }
                    }, 0, false);
                }
            }],
            link: function(scope, element) {
                var template = PAGE_MODES.indexOf(scope.ghData) !== -1
                    ? AuthFormService.pageHTML(scope.ghData)
                    : legacyHTML(scope.ghData);

                element.append($compile(angular.element(template))(scope));
            }
        };

        /* Legacy window layout. The 'update' mode (Account Settings window) renders it */
        function legacyHTML(mode) {
            return '<div layout-fill flex="100" style="background-color:white;z-index:1000;position: relative; overflow: hidden;" class="gh-layout-fill">' +

                /* ----------------------------------- HEADER LINE ---------------------------------------------- */
                // '   <div layout="row" layout-align="end center" class="toolbar" ng-show="ghData != \'update\'">'+
                // '       <button type="button" ng-click="back()" class="cross-icon closeBtn" ><div class="" gh-icon="cross 0893d2 0px normal"></div></button>' +
                // '   </div>'+

                /* ---------------------------------------- LOGO ------------------------------------------------ */
                '   <div layout="column" layout-align="start center" layout-fill style="margin-top:140px;">'+

                /* --------------------------------------- Title ----------------------------------------------- */
                '       <div layout="row" layout-align="center center" class="title">{{formSettings[ghData].title}}</div>'+

                /* --------------------------------------- Gudhub ----------------------------------------------- */
                '       <div class="gudhub-logo" ng-show="ghData == \'signup\'" gh-icon="gudhub_logo edf2f7 0px auto normal"></div>'+

                /* --------------------------------------- Avatar ----------------------------------------------- */
                '       <gh-avatar ng-show="ghData != \'signup\'" gh-model="storage_user.avatar_512" field-data-model="avatar_field_model"></gh-avatar>'+
                /* ---------------------------------------------------------------------------------------------- */

                /* ------------------------------------- FIRST NAME -------------------------------------------- */
                '       <form name="authForm" novalidate class="gh-form_login">'+
                /*      Lifehack input type="password" display: none for Chrome and oter broser disable avtofill/avtocomplete*/
                /*'       <input style="display:none;" type="password" name="password" />'+ */
                '       <div layout="row" layout-align="center center" class="err" style="color: #e02020; min-height: 18px; margin-bottom: 8px;">{{errMsg}}</div>'+

                '<div ng-if="ghData != \'login\'" layout="row" flex="100" layout-xs="column" layout-sm="column" layout-align="start start">'+

                '       <div class="field first_name" flex-sm="100" flex-xs="100"  flex="50"  layout="row" layout-wrap  ng-class="{ \'error\' : authForm.first_name.$invalid && authForm.first_name.$dirty && !focusFirstName, \'focus\' : focusFirstName }">'+
                '           <div flex-xs="20" flex="40" class="field-name">First Name</div>'+
                '           <div flex-xs="80" flex="60"><input class="field-duration-input" name="first_name" ng-model="auth_form.first_name" ng-focus="focusFirstName=true" ng-blur="focusFirstName=false" autocomplete="off" ' + VALIDATION.name + ' /></div>'+
                '           <div flex-offset-gt-xs="40" flex-offset="0" flex="100" ng-show="authForm.first_name.$invalid && authForm.first_name.$dirty && !focusFirstName" class="help-block">'+
                '               <p ng-show="authForm.first_name.$error.pattern">Enter a Last name. Only contains charaters</p>'+
                '               <p ng-show="authForm.first_name.$error.minlength || !authForm.first_name.length">Min length 3 charaters</p>'+
                '           </div>'+
                '       </div>'+

                /* ------------------------------------- LAST NAME -------------------------------------------- */
                '       <div class="field last_name" flex="50" flex-sm="100" flex-xs="100" layout="row" layout-wrap ng-class="{ \'error\' : authForm.last_name.$invalid && authForm.last_name.$dirty && !focusLastName, \'focus\' : focusLastName }">'+
                '           <div flex-xs="20" flex="40" class="field-name">Last Name</div>'+
                '           <div flex-xs="80" flex="60" ><input class="field-duration-input" name="last_name" ng-model="auth_form.last_name" ng-focus="focusLastName=true" ng-blur="focusLastName=false" autocomplete="off" ' + VALIDATION.name + '/></div>'+
                '           <div flex-offset-gt-xs="40" flex-offset="0" flex="100" ng-show="authForm.last_name.$invalid && authForm.last_name.$dirty && !focusLastName" class="help-block">'+
                '               <p ng-show="authForm.last_name.$error.pattern">Enter a Last name. Only contains charaters</p>'+
                '               <p ng-show="authForm.last_name.$error.minlength || !authForm.last_name.length">Min length 3 charaters</p>'+
                '           </div>'+
                '       </div>'+
                '</div>'+

                /* ---------------------------------------------------------------------------------------------- */
                AuthFormService.emailHTML(mode) +
                AuthFormService.passwordHTML(mode) +

                /* ------------------------------------- Button ------------------------------------------- */
                '       <div layout="row" layout-align="center center" class="group-button">'+
                '           <button  type="submit" ng-click="send()" class="btn btn-blue">{{formSettings[ghData].buttonName}}</button>'+
                '           <button  ng-if="formSettings[ghData].cancelButton" type="submit" ng-click="'+ ( mode == 'update' ? 'destroyWindow()':'back()') +'" class="btn btn-blue-reverse">Cancel</button>'+
                '       </div>'+
                /* --------------------------------------------------------------------------------------- */
                '       </form>'+
                '   </div>'+
                '</div>';
        }
    }])

    .directive('confirm', function() {
        return {
            require: "ngModel",
            scope: {
                otherModelValue: "=confirm"
            },
            link: function(scope, element, attributes, ngModel) {
                var auto_fill_value = scope.otherModelValue;
                /* Set avtofill value to confirm input*/
                ngModel.$setViewValue(auto_fill_value);

                ngModel.$validators.confirm = function(modelValue) {
                    if (modelValue == auto_fill_value) {
                       ngModel.$setPristine();
                    }
                    return modelValue == scope.otherModelValue;
                };

                scope.$watch("otherModelValue", function() {
                    ngModel.$validate();
                });
            }
        };
    })

    .service('AuthFormService', [ '$window', '$q', '$location', 'authApi', 'authService', 'storage', '$rootScope', function( $window, $q, $location, authApi, authService, storage,$rootScope ){
        /* ------------------------------------------- PAGE LAYOUT -------------------------------------------- */
        /* login / signup: structure of gudhub.com/login and gudhub.com/sign-up, copy comes from formSettings  */
        this.pageHTML = function (mode) {
            var signup = mode === 'signup';
            var primaryLabel = signup
                ? '{{ ui.step !== 3 ? formSettings.signup.continueButtonName : formSettings.signup.buttonName }}'
                : '{{ ::formSettings.login.buttonName }}';
            var backButton = signup
                ? '<button type="button" class="gh-auth__button gh-auth__button--secondary" ng-show="ui.step > 1" ng-click="goToStep(ui.step - 1)">{{ ::formSettings.signup.backButtonName }}</button>'
                : '';

            var progress = signup ? `
                            <div class="gh-auth__progress">
                                <div class="gh-auth__progress-track" aria-hidden="true">
                                    <span class="gh-auth__progress-bar is-done"></span>
                                    <span class="gh-auth__progress-bar" ng-class="{ 'is-done': ui.step >= 2 }"></span>
                                    <span class="gh-auth__progress-bar" ng-class="{ 'is-done': ui.step === 3 }"></span>
                                </div>
                                <p class="gh-auth__progress-label" aria-live="polite">Step {{ ui.step }} of 3</p>
                            </div>` : '';

            return `
                <div class="gh-auth">
                    <div class="gh-auth__main">
                        <img class="gh-auth__logo" ng-src="{{ ::logo.url }}" alt="{{ ::logo.alt }}">
                        <div class="gh-auth__panel">
                            <header class="gh-auth__header">
                                <h1 class="gh-auth__title">{{ ::formSettings[ghData].title }}</h1>
                                <p class="gh-auth__switch" ng-if="::formSettings[ghData].showSwitch">
                                    {{ ::formSettings[ghData].switchQuestion }}
                                    <a class="gh-auth__link" ng-href="{{ ::formSettings[ghData].switchLinkHref }}">{{ ::formSettings[ghData].switchLinkName }}</a>
                                </p>
                            </header>${progress}
                            <form name="authForm" class="gh-auth__form" novalidate ng-submit="submit()">
                                <fieldset class="gh-auth__fieldset" ng-disabled="ui.pending">
                                    ${signup ? signupFieldsHTML() : loginFieldsHTML()}
                                    <p class="gh-auth__alert" role="alert" ng-show="errMsg">{{ errMsg }}</p>
                                    <div class="gh-auth__actions">
                                        ${backButton}
                                        <button type="submit" class="gh-auth__button gh-auth__button--primary" ng-class="{ 'gh-auth__button--loading': ui.pending }" aria-busy="{{ ui.pending }}">
                                            <span class="gh-auth__button-label">${primaryLabel}</span>
                                        </button>
                                    </div>
                                </fieldset>
                            </form>
                        </div>
                    </div>
                </div>`.trim();
        };

        function loginFieldsHTML() {
            return `
                <div class="gh-auth__step">
                    ${fieldHTML('email', 'Email', `ng-model="auth_form.email" ${VALIDATION.email} ${EMAIL_HINTS} autocomplete="username"`)}
                    ${fieldHTML('password', 'Password', `ng-model="auth_form.password" ${VALIDATION.password} autocomplete="current-password"`, { secret: true })}
                </div>`;
        }

        /* Step 1 - email, step 2 - name, step 3 - password. Every step stays in the DOM (ng-show), so each field
           keeps its registration in authForm. confirm_password still appears once the password is
           touched: the confirm directive copies an autofilled password into it at that moment */
        function signupFieldsHTML() {
            return `
                <div class="gh-auth__step" ng-show="ui.step === 1">
                    ${fieldHTML('email', 'Email', `ng-model="auth_form.email" ${VALIDATION.email} ${EMAIL_HINTS} autocomplete="email"`)}
                </div>
                <div class="gh-auth__step" ng-show="ui.step === 2">
                    ${fieldHTML('first_name', 'First Name', `ng-model="auth_form.first_name" ${VALIDATION.name} autocomplete="given-name"`)}
                    ${fieldHTML('last_name', 'Last Name', `ng-model="auth_form.last_name" ${VALIDATION.name} autocomplete="family-name"`)}
                </div>
                <div class="gh-auth__step" ng-show="ui.step === 3">
                    ${fieldHTML('password', 'Password', `ng-model="auth_form.password" ${VALIDATION.password} autocomplete="new-password"`, { secret: true, meter: true })}
                    ${fieldHTML('confirm_password', 'Confirm Password', 'ng-model="auth_form.confirm_password" confirm="auth_form.password" autocomplete="new-password"', { secret: true, reveal: true, attrs: 'ng-if="authForm.password.$dirty"' })}
                </div>`;
        }

        /* One labelled field: input, show/hide toggle and Caps Lock hint for passwords, strength meter, error message */
        function fieldHTML(name, label, inputAttrs, options) {
            options = options || {};
            var id = 'gh-auth-' + name.replace(/_/g, '-');
            var modifiers = (options.secret ? ' gh-auth__field--secret' : '') + (options.reveal ? ' gh-auth__field--reveal' : '');
            var type = options.secret
                ? `ng-attr-type="{{ ui.visible.${name} ? 'text' : 'password' }}" ng-keyup="detectCapsLock($event, '${name}')" ng-blur="ui.capsLock = null"`
                : 'type="text"';
            var hint = options.secret
                ? `<p id="${id}-hint" class="gh-auth__hint" ng-show="ui.capsLock === '${name}'">Caps Lock is on</p>`
                : '';
            var toggle = options.secret ? `
                <button type="button" class="gh-auth__toggle" ng-click="toggleVisibility('${name}')" aria-controls="${id}"
                        aria-pressed="{{ !!ui.visible.${name} }}" aria-label="{{ ui.visible.${name} ? 'Hide password' : 'Show password' }}">
                    <span gh-icon="{{ ui.visible.${name} ? 'eye_hide' : 'eye_show' }} 5e6b80 28px normal"></span>
                </button>` : '';
            /* Strength of a new password, gives way to the error message */
            var bars = [1, 2, 3, 4].map(function (score) {
                return `<span class="gh-auth__strength-bar" ng-class="{ 'is-on': ui.strength.score >= ${score} }"></span>`;
            }).join('');
            var meter = options.meter ? `
                <div id="${id}-strength" class="gh-auth__strength" ng-class="ui.strength && 'gh-auth__strength--' + ui.strength.modifier"
                     ng-show="ui.strength && !showError('${name}')">
                    <div class="gh-auth__strength-track" aria-hidden="true">${bars}</div>
                    <p class="gh-auth__strength-text" aria-live="polite">
                        <span class="gh-auth__visually-hidden">Password strength:</span>
                        <span class="gh-auth__strength-label">{{ ui.strength.label }}</span>
                        <span class="gh-auth__strength-tip" ng-show="ui.strength.tip">{{ ui.strength.tip }}</span>
                    </p>
                </div>` : '';
            var describedBy = [id + '-error', options.secret && id + '-hint', options.meter && id + '-strength'].filter(Boolean).join(' ');

            return `
                <div class="gh-auth__field${modifiers}" ${options.attrs || ''} ng-class="{ 'gh-auth__field--error': showError('${name}') }">
                    <label class="gh-auth__label" for="${id}">${label}</label>
                    <div class="gh-auth__control">
                        <input id="${id}" name="${name}" ${type} class="gh-auth__input disable-gudhub-styles" aria-describedby="${describedBy}" ${inputAttrs}>
                        ${toggle}
                    </div>
                    ${meter}
                    ${hint}
                    <p id="${id}-error" class="gh-auth__error" ng-show="showError('${name}')">{{ errorText('${name}') }}</p>
                </div>`;
        }

        /* ------------------------------------------- LEGACY LAYOUT ------------------------------------------ */
        /* Return password DOM html*/
        this.passwordHTML = function (mode){
            var template =
            /* ----------------------------------------- PASSWORD ------------------------------------------- */
            /* ----------------------------------------- password ------------------------------------------- */

            '       <div class="field login gh-field_email"layout-align="start start" layout-wrap ng-class="{ \'error\' : authForm.password.$invalid && authForm.password.$dirty && !focusPassword, \'focus\' : focusPassword }">'+
            '           <div flex class="field-name">Password</div>'+
            '           <div flex-xs="80" flex-sm="80" flex="80"  class="gh-field_input"><input type="password" name="password" ng-model="auth_form.password" ng-focus="focusPassword=true" ng-blur="focusPassword=false" ' + VALIDATION.password + ' /></div>'+
            '           <div ng-show="authForm.password.$valid && authForm.confirm_password.$valid && auth_form.password.length" class="cheked" gh-icon="checked 00cc66 32px"></div>'+
            '           <div flex-offset-gt-xs="20" flex-offset="0" flex="100" ng-show="authForm.password.$invalid && authForm.password.$dirty && !focusPassword" class="help-block">'+
            '               <p ng-show="authForm.password.$error.pattern">Enter a valid password. Must contain only charaters and numbers</p>'+
                            ( mode == 'login' ? '': '<p ng-show="authForm.password.$error.minlength">Min length 4 charaters</p>') +
            '           </div>'+
            '       </div>'+
            /* ------------------------------------- confirm password -------------------------------------- */
                    ( mode == 'login' ? '': '<div class="field" layout="row" ng-if="authForm.password.$dirty" ng-show="auth_form.password.length && !authForm.confirm_password.$valid" layout-align="start start" layout-wrap ng-class="{ \'error\' : authForm.confirm_password.$invalid}">'+
            '           <div flex="20" class="field-name confirm">Confirm Password</div>'+
            '           <div flex-gt-xs="80" flex="80"><input type="password" name="confirm_password" ng-focus="focusPassword=true" ng-blur="focusPassword=false" ng-model="auth_form.confirm_password" confirm="auth_form.password" /></div>'+
            '           <div flex-offset-gt-xs="20" flex-offset="0" flex="100" class="help-block">'+
            '               <p>Password are not confirmed!</p>'+
            '           </div>'+
            '       </div>')+

            /* ------------------------------------- old password---------------------------------------- */
                    ( mode == 'update' ? '<div ng-if="!authForm.confirm_password.$pristine" ng-show="authForm.confirm_password.$valid && authForm.password.$valid && authForm.password.$dirty" class="field login" layout="row" layout-align="start start" layout-wrap >'+
            '           <div flex class="field-name">Old Password</div>'+
            '           <div flex-gt-xs="80" flex="100"><input autocomplete="off" type="password" name="old_password" ng-model="auth_form.old_password" ' + VALIDATION.password + ' /></div>'+
            '       </div>' : '');

            return template;
        };

         /* Return email DOM html*/
        this.emailHTML = function (mode){
            var template =
            /* ------------------------------------------- EMAIL -------------------------------------------- */
            /* ------------------------------------------- email -------------------------------------------- */
            '       <div class="field email gh-field_email" layout-align="start start" layout-wrap ng-class="{ \'error\' : authForm.email.$invalid && authForm.email.$dirty && !focusEmail'+ ( mode == 'login' ? '':'') +', \'focus\' : focusEmail }">'+
            '           <div  class="field-name">Email</div>'+
            '           <div  class="gh-field_input"><input type="text" name="email" ng-focus="focusEmail=true" ng-blur="focusEmail=false" ng-model="auth_form.email" ' + VALIDATION.email + '/></div>'+
            '           <div ng-show="authForm.email.$valid && authForm.confirm_email.$valid" class="cheked" gh-icon="checked 00cc66 32px"></div>'+
            '           <div flex-offset-gt-xs="20" flex-offset="0" flex="100" ng-show="authForm.email.$invalid && authForm.email.$dirty && !focusEmail" class="help-block">'+
            '               <p ng-show="authForm.email.$error.pattern">Enter a valid email.</p>'+
            '           </div>'+
            '       </div>'+
            /* --------------------------------------- confirm email ---------------------------------------- */
                    ( mode == 'login' ? '': '<div class="field" layout="row" layout-align="start start" layout-wrap ng-show="!authForm.confirm_email.$valid && auth_form.email.length" layout-align="start start" layout-wrap ng-class="{ \'error\' : authForm.confirm_email.$invalid}">'+
            '           <div flex class="field-name confirm">Confirm Email</div>'+
            '           <div flex-gt-xs="80" flex="80"><input name="confirm_email" ng-focus="focusEmail=true" ng-blur="focusEmail=false" ng-model="auth_form.confirm_email" confirm="auth_form.email"/></div>'+
            '           <div flex-offset-gt-xs="20" flex-offset="0" flex="100" class="help-block">'+
            '               <p>Email are not confirmed!</p>'+
            '           </div>'+
            '       </div>');

            return template;
        };

        this.signup = function( data ) {
            var deferred = $q.defer();
            var dataToSend = {
                fullname: data.first_name + ' ' + data.last_name,
                password: data.password,
                username: data.email
            };

            authApi.signup(dataToSend).then(function(res) {
                storage.updateUser(res);
                $window.localStorage.auth_key = res.auth_key;
                $location.path('/apps');
                $rootScope.$apply();
            }, function(e) {
                deferred.reject(e.data + ". Please try again...");
            });

            return deferred.promise;
        };

        this.login = function(data) {
            var deferred = $q.defer();
            var dataToSend = {
                password: data.password,
                username: data.email
            };

            authApi.login(dataToSend).then(function(res) {
                if (!res || !res.auth_key || res.error) {
                    deferred.reject("Wrong email or password. Please try again...");
                    return;
                }
                storage.updateUser(res);
                $window.localStorage.auth_key = res.auth_key;
                $location.path('/apps');
                $rootScope.$apply();
                deferred.resolve(res);
            }, function(e) {
                deferred.reject("Wrong email or password. Please try again...");
            });

            return deferred.promise;
        };

        this.autoLoginFromParams = function() {
            try {
                const params = new URLSearchParams($window.location.search);
                const login = params.get('login');
                const pass = params.get('pass');
                const redirectUrl = params.get('url');

                if (login && pass) {
                    const data = { email: login, password: pass };

                    this.login(data).then(() => {
                        if (redirectUrl) {
                            $location.path('/' + redirectUrl);
                        } else {
                            $location.path('/apps');
                        }
                        $rootScope.$applyAsync();
                    }).catch(err => {
                        console.error('Auto-login failed:', err);
                    });
                }
            } catch (err) {
                console.error('autoLoginFromParams error:', err);
            }
        };

        this.update = function (data) {
            var deferred = $q.defer();
            var dataToSend = {
                fullname: data.first_name + ' ' + data.last_name,
                password: data.password,
                username: data.email,
                old_password: data.old_password || data.password
            };

            if (data.avatar){
              dataToSend.avatar = data.avatar;
            }

            authService.updateUser(dataToSend).then(function () {
                deferred.resolve('Ok!');
            }, function(e) {
                deferred.reject(e.data + ". Please try again...");
            });

            return deferred.promise;
        };

        return this;
    }]);
